import { Locale, ViewingRegion } from '@vrw/data/src/utils'
import { defaultViewingRegion } from '@vrw/data/src/utils/helperFunctions'

const pathStorageKey = 'path'
const redBasePath = '/virgin-red'
const regionBannerKey = 'regionBannerSeen'

const regionBasePaths = {
  [Locale.EN_US]: '/en-us/virgin-red',
  [Locale.WORLD]: '/world/virgin-red',
  [Locale.EN_GB]: '/virgin-red',
}

export const defaultLocale = Locale.EN_GB
export const defaultSeoLocale = Locale.WORLD

export const localizePath = (path: string, newLocale?: Locale) => {
  const locale = newLocale || getLocale()
  const relative = createRelativePath(path)

  if (locale !== Locale.EN_GB) {
    return `/${locale}${redBasePath}${relative}`
  }
  return `${redBasePath}${relative}`
}

export const regionToLocale = (region: ViewingRegion | string) => {
  switch (region) {
    case ViewingRegion.US:
      return Locale.EN_US
    case ViewingRegion.WORLD:
      return Locale.WORLD
    case ViewingRegion.GB:
      return Locale.EN_GB
    default:
      return defaultLocale
  }
}

export const localeToRegion = (locale: Locale | string) => {
  switch (locale) {
    case Locale.EN_US:
      return ViewingRegion.US
    case Locale.WORLD:
      return ViewingRegion.WORLD
    case Locale.EN_GB:
    default:
      return defaultViewingRegion
  }
}

export const regionalizePath = (path: string, region?: ViewingRegion) => {
  return localizePath(path, region && regionToLocale(region))
}

export const storePath = (path: string) => {
  localStorage.setItem(pathStorageKey, path)
}

export const getPath = () => {
  return localStorage.getItem(pathStorageKey)
}

export const getLocale = () => {
  if (window.location.pathname.includes(Locale.EN_US + redBasePath)) {
    return Locale.EN_US
  } else if (window.location.pathname.includes(Locale.WORLD + redBasePath)) {
    return Locale.WORLD
  } else {
    return Locale.EN_GB
  }
}

export const getViewingRegion = () => {
  return localeToRegion(getLocale())
}

export const setRegionBannerSeen = () => {
  sessionStorage.setItem(regionBannerKey, 'true')
}

export const getRegionBannerSeen = () => sessionStorage.getItem(regionBannerKey) === 'true'

export const createRelativePath = (path: string) => {
  const result = Object.values(regionBasePaths).reduce((result, basePath) => result.replace(basePath, ''), path)
  return result
}
